import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#060910]">
      <div className="mx-auto max-w-7xl px-6 py-16 md:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <img
              src="/tosiase-logo.png"
              alt="Tosiase Creatives"
              className="h-16 w-auto rounded-xl bg-white/95 p-1.5 shadow-[0_8px_32px_rgba(0,0,0,0.5)]"
            />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
              A venture ecosystem from Jaipur — an active food kitchen funds IT platform development, which in turn
              supports agro-research and foundation initiatives.
            </p>
            <a
              href="mailto:tosiasi@tosiasicreatives.com"
              data-testid="footer-email-link"
              className="mt-6 inline-flex items-center gap-2 text-sm text-amber-400 transition-colors duration-300 hover:text-amber-300"
            >
              <Mail size={15} /> tosiasi@tosiasicreatives.com
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow">Ventures</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/nokchhonk" data-testid="footer-link-nokchhonk" className="text-slate-300 transition-colors hover:text-amber-400">
                  Nok Chhonk — Cloud Kitchen
                </Link>
              </li>
              <li>
                <Link to="/mozekaql" data-testid="footer-link-mozekaql" className="text-slate-300 transition-colors hover:text-cyan-400">
                  Mozekaql — IT &amp; Agro-Research
                </Link>
              </li>
            </ul>
            <p className="eyebrow mt-8">Company</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/" data-testid="footer-link-home" className="text-slate-300 transition-colors hover:text-white">Home</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="text-slate-300 transition-colors hover:text-white">About Us</Link></li>
              <li>
                <Link to="/contact" data-testid="footer-link-contact" className="inline-flex items-center gap-1 text-slate-300 transition-colors hover:text-white">
                  Contact <ArrowUpRight size={13} />
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow">Registered Office</p>
            <p className="mt-5 flex items-start gap-2 text-sm leading-relaxed text-slate-300">
              <MapPin size={15} className="mt-0.5 shrink-0 text-cyan-400" />
              Vaishali Nagar, Jaipur, Rajasthan, India
            </p>
            <div className="glass mt-6 rounded-2xl p-5">
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">CIN</p>
              <p className="mt-1 font-mono text-xs text-slate-300">U55101RJ2025PTC109155</p>
              <div className="mt-4 flex flex-wrap gap-2">
                <span className="rounded-full border border-amber-400/30 bg-amber-400/10 px-3 py-1 text-[11px] text-amber-300">
                  FSSAI Licensed
                </span>
                <span className="rounded-full border border-cyan-400/30 bg-cyan-400/10 px-3 py-1 text-[11px] text-cyan-300">
                  Startup India Recognized
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/5 pt-8 text-xs text-slate-500 md:flex-row md:items-center">
          <p>© 2026 TOSIASI CREATIVES PRIVATE LIMITED. All rights reserved.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em]">Incorporated December 2, 2025 · Jaipur, Rajasthan</p>
        </div>
      </div>
    </footer>
  );
}
